import React from 'react';
import { ScreenSize } from 'glints-aries';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';

import * as Styled from './ErrorStyles.sc';

// Dynamically import TakeMeHomeButton to avoid SSR issues with Redux state
const TakeMeHomeButton = dynamic(
  () => import('./TakeMeHomeButton').then(mod => mod.TakeMeHomeButton),
  {
    ssr: true,
    loading: () => (
      <Styled.Button href="/">
        <FormattedMessage
          id="error_home.button"
          defaultMessage="Take me home!"
        />
      </Styled.Button>
    ),
  }
);

const Error404Page = () => (
  <>
    <MetadataRenderer title="Page Not Found" glintsTrackingName="error_404" />
    <Styled.Container>
      <Styled.Image
        name="error/404.png"
        sizes={`(min-width: ${ScreenSize.tablet}px) 597px, 100vw`}
        alt="404 Not Found"
      />
      <FormattedMessage
        id="error.404_page.title"
        defaultMessage="Page Not Found"
        tagName={Styled.Title}
      />
      <FormattedMessage
        id="error.404_page.description"
        defaultMessage="Whoops, you may have wandered too far!{br}(The page you have requested was not found or might have been moved.)"
        tagName={Styled.Description}
        values={{ br: <br /> }}
      />
      <TakeMeHomeButton />
    </Styled.Container>
  </>
);

export default Error404Page;
